export default {
  title: 'Heute',
  greeting: { morning: 'Guten Morgen', day: 'Guten Tag', evening: 'Guten Abend' },
  /** Kalenderwoche im Kopf, z. B. „KW 44". */
  week: 'KW {n}',
  longDate: '{weekday}, {day}. {month} {year}',
  accountAndMore: 'Konto und Mehr',
  loadError: 'Heute lässt sich gerade nicht laden.',
  retry: 'Nochmal versuchen',
  loading: 'Lädt …',
  heatmapLabel: 'Trainings-Heatmap',
  heatmapMobile: 'Letzte 20 Wochen',
  heatmapDesktop: 'Trainingsminuten, letzte 12 Monate',
  trainingMinutes: 'Trainingsminuten',
  heatmapError: 'Heatmap nicht verfügbar: {error}',
  formEmpty: 'Fitness und Form erscheinen, sobald Aktivitäten mit Trainingslast da sind.',
  formError: 'Fitness/Form nicht verfügbar: {error}',
  garminAttribution: 'Garmin-Daten mit Genehmigung von Garmin',
  upload: {
    created: 'Aktivität angelegt.',
    duplicate: 'Schon vorhanden – keine Dublette angelegt.',
    failed: 'Upload fehlgeschlagen: {error}',
    busy: 'Lädt …',
    button: 'FIT hochladen',
  },
  ampel: {
    label: 'Ampel',
    /** Ruhepuls-Kachel mobil, wo vier Kacheln nebeneinander stehen. */
    rhrShort: 'Ruhepuls',
    level: { green: 'Grün', yellow: 'Gelb', red: 'Rot' },
    advice: { green: 'frei trainieren', yellow: 'locker', red: 'Ruhe oder sehr locker' },
    asOf: 'Ampel · Stand {date}',
    tomorrow: 'Ampel für morgen · ab 18 Uhr',
    today: 'Ampel für heute',
    allGreen: 'Alle gemessenen Signale im grünen Bereich.',
    notSynced: ' Heute noch nicht synchronisiert.',
    missing: ' {missing} von 4 Signalen fehlen.',
    emptyTitle: 'Noch keine Health-Daten',
    emptyText: 'Sobald Garmin Schlaf, HRV, Body Battery und Ruhepuls liefert, steht hier die Ampel.',
    weekStreak: 'Wochenserie',
    streakWord: 'Serie',
    restart: 'neu starten',
  },
  streak: {
    label: 'Wochenserie',
    endsToday: 'Woche endet heute',
    endsOn: 'Woche endet {date}',
    secured: 'diese Woche gesichert',
    open: 'diese Woche noch offen',
    none: 'keine laufende Serie',
    aria: 'Wochenserie {weeks} Wochen, {status}',
    weeks: { one: '{count} Woche', other: '{count} Wochen' },
    restartTitle: 'Serie neu starten',
    securedBy: 'Diese Woche gesichert:',
    securedDetail: '{sport} {minutes} am {day}',
    openLine1: 'Diese Woche noch offen –',
    openLine2: 'eine Einheit bis {date} hält die Serie.',
    startLine1: '1 Aktivität diese Woche',
    startLine2: 'startet eine neue Serie.',
    since: 'seit {date}',
    recentAria: 'Letzte {n} Wochen: {active} mit Training',
    weekTitle: 'Woche ab {date}: {state}',
    withTraining: 'mit Training',
    withoutTraining: 'ohne Training',
    lastWeeks: 'Letzte {n} Wochen',
    withActivity: 'mit Aktivität',
    without: 'ohne',
  },
  thisWeek: {
    label: 'Diese Woche',
    title: 'Diese Woche · {time}',
    secured: 'Wochenserie gesichert',
    oneMore: 'Wochenserie: noch 1 Einheit',
    noTraining: 'noch kein Training',
    dayNoTraining: '{date} · kein Training',
    /** Anfangsbuchstaben Mo–So unter den Balken. */
    dayLetters: 'MDMDFSS',
  },
  year: {
    aria: 'Jahr {year}',
    soFar: '{year} bisher',
    until: 'bis {date}',
    empty: 'Noch keine Aktivität in diesem Jahr.',
  },
  recent: {
    label: 'Letzte Aktivitäten',
    all: 'Alle ansehen',
    empty: 'Noch keine Aktivitäten. Synchronisiere Garmin oder lade eine FIT-Datei hoch.',
    race: 'Wettkampf',
    estimated: 'geschätzt ohne Herzfrequenz',
    fromHr: 'aus der Herzfrequenz',
    avgHr: 'Ø {hr} bpm',
    source: { garmin: 'Garmin', strava: 'Strava-Export', fit: 'FIT-Upload' },
  },
  form: {
    range90: '90 Tage',
    range365: '12 Monate',
    fitness: 'Fitness (CTL)',
    fatigue: 'Ermüdung (ATL)',
    form: 'Form (TSB)',
    ariaLabel: 'Fitness {ctl}, Ermüdung {atl}, Form {tsb} ({word})',
    ariaRaces: '; Wettkämpfe: {races}',
    raceOn: '{title} am {date}',
    noLoad: 'Keine Trainingslast im Zeitraum',
    title: 'Fitness, Ermüdung, Form',
    subtitle: 'Last selbst berechnet (hrTSS)',
    range: 'Zeitraum',
    formWord: 'Form ({word})',
    legendFitness: 'Fitness (CTL, 42 Tage)',
    legendFatigue: 'Ermüdung (ATL, 7 Tage)',
    legendForm: 'Form (TSB)',
    legendRace: 'Wettkampf',
    /** Achsenbeschriftung für Tage, die kein Monatserster sind. */
    axisDay: '{day}.{month}.',
  },
  heatmap: {
    noTraining: 'kein Training',
    more: ' + {n} weitere',
    summary: '{days} Trainingstage · längste Pause {pause}',
    pauseDays: { one: '{count} Tag', other: '{count} Tage' },
    aria: 'Trainingsminuten der letzten {weeks} Wochen: {days} Trainingstage, längste Pause {pause} Tage',
    legend: { l0: 'kein Training', l1: '1–29 min', l2: '30–59 min', l3: '1–2 h', l4: 'ab 2 h' },
    less: 'weniger',
    moreLegend: 'mehr',
  },
  comment: {
    label: 'Wochenkommentar',
    title: 'Wochenkommentar · KW {week}',
    new: 'Neu',
    busy: 'Erzeugt …',
    regenerate: 'Neu erzeugen',
    generate: 'Jetzt erzeugen',
    meta: 'KI · {model} · Basis: {basis}',
    none: 'Für die letzte Woche gibt es noch keinen Kommentar – er entsteht montags von selbst.',
    failed: 'Nicht erzeugt: {error}',
    otherLang: 'Auf Englisch erstellt',
  },
};
